import React, { Component } from 'react'
import Create from '../../../crud/create'
import api from '../../../../api'
import fields from './payment-fields'

class CreatePayment extends Component<any, any> {
  constructor (props) {
    super(props)
    this.state = {
      paymentProviders: []
    }
  }

  componentDidMount () {
    api
      .get('admin/payment_providers')
      .then(res => res.json())
      .then(paymentProviders => {
        this.setState({ paymentProviders })
      })
  }

  render () {
    const { order } = this.props
    const orderPath = `/ecommerce/orders/${order.id}/manage`

    const textList = [
      {
        text: 'Outstanding Balance: ',
        value: order.order_balance ? order.order_balance : order.order_total
      }
    ]

    return (
      <Create
// @ts-ignore
        title='Create Payment'
        textList={textList}
        fields={fields(this.state.paymentProviders)}
        apiPath='admin/payments'
        successRedirectPath={orderPath}
        cancelRedirectPath={orderPath}
        onResourceCreated={this.props.onPaymentCreated}
        onCancel={this.props.onPaymentCanceled}
        resource={{
          payment_date: new Date(),
          order_id: order.id
        }}
      />
    )
  }
}

export default CreatePayment
